<template>
    <div id="application">
        <div class="search-box">
            <p>应用资源code：</p>
            <a-input allow-clear v-model="code"/>
            <p>应用资源名称：</p>
            <a-input allow-clear v-model="name"/>
            <a-button type="primary" icon="search" class="search-btn" @click="refreshTable">搜索</a-button>
            <a-button type="primary" icon="plus" class="add-btn" @click="okText='新增';showAdd=true">新增</a-button>
        </div>
        <a-table
            :columns="columns"
            :data-source="data"
            :pagination="pagination"
            :loading="loading"
            @change="handleTableChange"
            bordered
        >
            <span slot="enable" slot-scope="text">{{text?'启用':'禁用'}}</span>

            <span slot="idNum">{{pagination.pageSize}}</span>
            <span slot="id" slot-scope="text, record">
                <a v-if="record.enable" @click="disable(record)">禁用</a>
                <a v-if="!record.enable" @click="enable(record)">启用</a>
                <a-divider type="vertical"/>
                <a @click="delPower(record)">删除</a>
            </span>
            <template slot="name" slot-scope="name"> {{ name.first }} {{ name.last }} </template>
        </a-table>
        <a-drawer
            title="新增应用"
            placement="right"
            :closable="false"
            :visible="showAdd"
            :width=500
            @close="cancelAdd"
        >
            <div class="input-box">
                <p>应用code：</p>
                <a-input allow-clear v-model="form.code" maxLength='50'/>
            </div>
            <div class="input-box">
                <p>应用名称：</p>
                <a-input allow-clear v-model="form.name" maxLength='50'/>
            </div>
            <div class="input-box">
                <p>用户名：</p>
                <a-input allow-clear v-model="form.userName" maxLength='50'/>
            </div>
            <div class="input-box">
                <p>密码：</p>
                <a-input-password v-model="form.password" class="input-box"/>
            </div>
            <div class="input-box">
                <p>确认密码：</p>
                <a-input-password v-model="password" class="input-box" @change="checkingPassword"/>
            </div>
            <div class="input-box">
                <p>服务IP：</p>
                <a-input allow-clear v-model="form.serverIp" maxLength='50'/>
            </div>
            <div class="input-box">
                <p>状态：</p>
                <a-switch default-checked v-model="form.enable"/>
            </div>
            <div class="drawer-btn">
                <a-button :style="{ marginRight: '8px' }" @click="cancelAdd">取消</a-button>
                <a-button type="primary" @click="addApps">新增</a-button>
            </div>
        </a-drawer>
        <!-- <a-modal v-model="showAdd" :title="okText+'权限'" @ok="addPower" @cancel='cancelAdd' cancelText="取消" :okText='okText'>
            <div class="input-box">
                <p>权限名：</p>
                <a-input allow-clear v-model="addName" maxLength='50'/>
            </div>
            <div class="input-box">
                <p>权限标识：</p>
                <a-input allow-clear v-model="addPermission" maxLength='50' :disabled="okText!='新增'?true:false"/>
            </div>
        </a-modal> -->
    </div>
</template>

<script>
const columns = [
    {
        title: '序号',
        dataIndex: 'idNum',
    },
    {
        title: '应用code',
        dataIndex: 'code',
    },
    {
        title: '应用名称',
        dataIndex: 'name',
    },
    {
        title: '用户名',
        dataIndex: 'userName',
    },
    {
        title: '服务端IP',
        dataIndex: 'serverIp',
    },
    {
        title: '更新时间',
        dataIndex: 'lastUpdateTime',
    },
    {
        title: '状态',
        dataIndex: 'enable',
        scopedSlots: { customRender: 'enable' },
    },
    {
        title: '操作',
        dataIndex: 'id',
        width: 150,
        scopedSlots: { customRender: 'id' },
    },
];
export default {
  name: 'Application',
  components: {
  },
  data() {
    return {
        data: [],
        pagination: {},
        loading: false,
        columns,
        code:'',
        name:'',
        tableSize:10,
        showAdd: false,
        addName:'',
        addPermission:'',
        okText:'',
        putId:'',
        form:{
            code:'',
            name:'',
            userName:'',
            password:'',
            serverIp:'',
            enable:true,
        },
        isAdd:true,
        checkingTime:''
    }
  },
  mounted () {
    this.refreshTable();
  },
  methods:{
    handleTableChange(pagination) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.fetch({
        size: pagination.pageSize,
        current: pagination.current,
        name:this.name,
        code:this.code,
      });
    },
    fetch(params = {}) {
        this.pagination = params;
        this.loading = true;
        this.baseAPI.axiosData('/api-u/apps?size='+params.size+'&current='+params.current+'&name='+params.name+'&code='+params.code,'get',{}).then(res => {
            const pagination = { ...this.pagination };
            pagination.pageSize = params.size;
            pagination.total = res.data.total;
            for(let i=0;i<res.data.records.length;i++)
            {
                res.data.records[i].idNum=(params.size*(params.current-1))+i+1;
            }
            this.loading = false;
            this.data = res.data.records;
            this.pagination = pagination;
        })
    },
    addPower()
    {
        if(this.okText=='新增')
        {
            let dataObj={
                permission:this.addPermission,
                name:this.addName
            }
            this.baseAPI.axiosData('/api-u/permissions','post',dataObj).then(res => {
                if(res.data.success)
                {
                    this.$notification['success']({
                        message: '添加成功',
                    });
                }
                else
                {
                    this.$notification['error']({
                        message: res.data.errorMessage,
                    });
                }
                this.addPermission='';
                this.addName='';
                this.showAdd = false;
            })
        }
        else if(this.okText=='修改')
        {
            let dataObj={
                name:this.addName,
                permission:this.addPermission,
                id:this.putId,
            };
            this.baseAPI.axiosData('/api-u/permissions','PUT',dataObj).then(res => {
                if(res.data.success)
                {
                    this.$notification['success']({
                        message: '修改成功',
                    });
                }
                else
                {
                    this.$notification['error']({
                        message: res.data.errorMessage,
                    });
                }
                this.addPermission='';
                this.addName='';
                this.showAdd = false;
            })
        }
        this.refreshTable();
    },
    cancelAdd(){
        this.showAdd=false;
        this.form={
            code:'',
            name:'',
            userName:'',
            password:'',
            serverIp:'',
            enable:true,
        }
        this.password='';
    },
    delPower(obj){
        var that=this;
        this.$confirm({
            title: '警告',
            content: '确定删除该权限吗？',
            onOk() {
                that.baseAPI.axiosData('/api-u/apps/'+obj.id,'DELETE',{}).then(res => {
                    console.log(res)
                    if(res.data.success)
                    {
                        that.$notification['success']({
                            message: '删除成功',
                        });
                    }
                    else
                    {
                        that.$notification['error']({
                            message: res.data.errorMessage,
                        });
                    }
                    that.refreshTable();
                })
                // return new Promise((resolve, reject) => {
                //     setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
                // }).catch(() => console.log('Oops errors!'));
            },
            onCancel() {},
        });
    },
    checkingPassword(){
        clearTimeout(this.checkingTime);
        var that=this;
        this.checkingTime=setTimeout(()=>{
            if(that.password!=that.form.password)
            {
                that.isAdd=false;
                that.$notification['error']({
                    message: '两次输入密码不一致',
                });
            }
            else
            {
                that.isAdd=true;
            }
        },1000)
    },
    addApps(){
        console.log(this.form)
        if(this.form.code==''||this.form.name==''||this.form.userName==''||this.form.password==''||this.form.serverIp==''||!this.isAdd)
        {
            this.$notification['error']({
                message: '请填写完整',
            });
        }
        else
        {
            this.baseAPI.axiosData('/api-u/apps','post',this.form).then(res => {
                if(res.data.success)
                {
                    this.showAdd=false;
                    this.form={
                        code:'',
                        name:'',
                        userName:'',
                        password:'',
                        serverIp:'',
                        enable:true,
                    }
                    this.password='';
                    this.refreshTable();
                    this.$notification['success']({
                        message: '新增成功',
                    });
                }
                else
                {
                     this.$notification['error']({
                        message: res.data.errorMessage,
                    });
                   
                }
            })
        }
    },
    refreshTable(){
        this.fetch({
            size: this.tableSize,
            current: 1,
            name:this.name,
            code:this.code,
        });
    },
    disable(obj)
    {
        this.baseAPI.axiosData('/api-u/apps/disable/'+obj.id,'post',{}).then(res => {
            if(res.data.success)
            {
                this.refreshTable();
                this.$notification['success']({
                    message: '禁用成功',
                });
            }
        })
    },
    enable(obj)
    {
        this.baseAPI.axiosData('/api-u/apps/enable/'+obj.id,'post',{}).then(res => {
            if(res.data.success)
            {
                this.refreshTable();
                this.$notification['success']({
                    message: '启用成功',
                });
            }
        })
    }
  }
}
</script>

<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 24px;
    }
    .search-box p
    {
        display: inline-block;
        margin-left: 2rem;
    }
    .search-box p:nth-child(1)
    {
        margin-left: 0;
    }
    .search-box .ant-input-affix-wrapper
    {
        width: 14rem;
    }
    .search-box .search-btn
    {
        margin-left: 2rem;
    }
    .search-box .add-btn
    {
        float: right;
    }
    .input-box
    {
        margin-bottom: 1rem;
    }
    .input-box p
    {
        display: inline-block;
        width: 20%;
        text-align: right;
    }
    .input-box .ant-input-affix-wrapper
    {
        width: 80%;
    }
    .anticon
    {
        font-size: 20px;
        margin-right: 1rem;
        cursor: pointer;
    }
    .anticon:hover
    {
        color: #1890ff;
    }
    a{
      display: inline-block;
      text-decoration: none;
      color: #1F5EFF;
    }
    .drawer-btn
    {
        position: absolute;
        width: 100%;
        right: 0;
        bottom: 0;
        border-top: 1px solid #e9e9e9;
        padding: 10px 16px;
        text-align: right;
        z-index: 1;
    }
</style>
